import { Component, OnInit } from '@angular/core';
import {AuthServiceService} from '../../../shareModule/services/auth-service.service';
import {LocalServiceService} from '../../../shareModule/services/local-service.service';
import {Router} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-sub-sub-admin',
  templateUrl: './sub-sub-admin.component.html',
  styleUrls: ['./sub-sub-admin.component.scss']
})
export class SubSubAdminComponent implements OnInit {

  adminImg:any;
  name:any;
  actions=[];
  constructor(private auth:AuthServiceService,private local:LocalServiceService,private router:Router,private toastr: ToastrService) { }

  ngOnInit(): void {
    // this.getProfileDetail();
    this.getActions()
  }

  getProfileDetail(){
    this.auth.getProfile().subscribe((response:any)=>{
      this.name = response.body.userName;
      this.adminImg = `http://3.0.142.216:3012/'${response.body.image}`;
      
    },(error)=>{
      if(error.status == 401){
        this.local.logout();
        this.router.navigate(['/admin'])
      }
    })
  }

  getActions(){
    this.auth.get_all_actions().subscribe((response:any)=>{
      this.actions = response.body;
      // console.log('-------------',response);
    })

  }

  deleteCust(id){

    Swal.fire({
      title: 'Are you sure?',
      text: "You want to delete this member",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {

        let data = {'userId':id}

        this.auth.deleteMember(data).subscribe((response:any)=>{
          Swal.fire(
            'Deleted!',
            'Your member has been deleted.',
            'success'
          )
          window.location.reload();
        },(e)=>{
          if(e.status == 401){
            this.local.logout();
            this.router.navigate(['/admin']);
          }else{
            this.toastr.error(e.error.message);
          }
        })
      }
    })
    return;

   
  }

  onImgError(event) { 
    event.target.src = '../../../assets/images/default.png';
}
}
